import type { RouteRecordRaw } from 'vue-router';

const PublicLayout = () => import('@/shared/layouts/pages/PublicLayout/index.vue');
const LegalRepConfirmView = () => import('@/shared/legalRepConfirmation/pages/LegalRepConfirmView/index.vue');

export const legalRepConfirmationPublicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/confirmation',
    component: PublicLayout,
    children: [
      {
        path: 'legalrepresentatives/declaration',
        name: 'legal-rep-declaration',
        component: LegalRepConfirmView,
      },
    ],
  },
];
